const types = {
  SET_TRAINING_REQUESTS: "SET_TRAINING_REQUESTS",
  SET_TRAINING_REQUEST: "SET_TRAINING_REQUEST",
};

export default types;
